// Mothers' Garden (2026-10-12): a kosárfiók ajánlója a kosár ÖSSZES terméke alapján fésül össze
// (sections/mg-drawer-recs.liquid), és kihagyja, ami már a kosárban van vagy elfogyott.
// Ha ez nem ad eredményt (nincs kézi lista), a Shopify saját ajánlása jön az első kosártermék alapján,
// ugyanezen a szekción át szűrve; végső esetben az eredeti data-url, a kosárban lévők kiszűrésével.
class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const mergedUrl = root + 'cart?section_id=mg-drawer-recs';
    const originalUrl = this.dataset.url;
    const fallbackUrl = originalUrl
      ? originalUrl.replace(/section_id=[^&]*/, 'section_id=mg-drawer-recs').replace(/limit=\d+/, 'limit=10')
      : null;

    this.load(mergedUrl, false)
      .catch(() => null)
      .then(recommendations => recommendations || (fallbackUrl ? this.load(fallbackUrl, false).catch(() => null) : null))
      .then(recommendations => recommendations || (originalUrl ? this.load(originalUrl, true) : null))
      .then(recommendations => {
        if (recommendations) {
          this.innerHTML = recommendations.innerHTML;
        }
        // Scroll the mini-cart drawer to the top after recommendations load
        const miniCartMain = document.querySelector('#main-cart-items');
        if (miniCartMain) {
          miniCartMain.scrollTop -= miniCartMain.scrollHeight;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  load(url, filterInCart) {
    return fetch(url)
      .then(response => (response.ok ? response.text() : ''))
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (!recommendations) return null;
        if (filterInCart) {
          const inCart = new Set(
            Array.from(document.querySelectorAll('cart-items li[data-handle]')).map(li => li.dataset.handle)
          );
          recommendations.querySelectorAll('.mini-cart__navigation > li').forEach(li => {
            const link = li.querySelector('a[href*="/products/"]');
            if (!link) return;
            const handle = decodeURIComponent(link.getAttribute('href').split('/products/')[1].split(/[?#/]/)[0]);
            if (inCart.has(handle)) li.remove();
          });
        }
        return recommendations.querySelector('.mini-cart__navigation > li') ? recommendations : null;
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);